import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  Box,
  IconButton,
} from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";

const Disclaimer = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("disclaimerAccepted");
    if (!accepted) {
      setShowModal(true);
    }
  }, []);

  const handleProceed = () => {
    localStorage.setItem("disclaimerAccepted", "true");
    setShowModal(false);
  };

  return (
    <Dialog
      open={showModal}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "24px",
          p: 2,
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          pb: 1,
          fontFamily: "'Roboto Slab', serif",
          fontWeight: 800,
        }}
      >
        <GavelIcon sx={{ color: "var(--primary-color)" }} />
        Disclaimer
      </DialogTitle>
      <DialogContent dividers sx={{ borderTop: "1px solid #eee" }}>
        <Box sx={{ py: 2 }}>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "#444",
              lineHeight: 1.8,
              fontSize: "0.95rem",
              textAlign: "justify",
            }}
          >
            The Institute of Chartered Accountants of India does not permit
            advertisement or solicitation by Chartered Accountants in any form
            or manner. By accessing this website,{" "}
            <strong>www.vdoogar.com</strong>, you acknowledge and confirm that
            you are seeking information relating to V Doogar and Associates on
            your own accord and that there has been no form of solicitation,
            advertisement or inducement by V Doogar and Associates or its
            partners or employees.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#444",
              lineHeight: 1.8,
              fontSize: "0.95rem",
              textAlign: "justify",
            }}
          >
            The contents of this website are for informational purposes only and
            should not be interpreted as soliciting or advertising. No
            information provided on this website should be used or construed as
            substitute of professional advice. V Doogar and Associates shall not
            be liable for consequences of any action taken by relying on the
            information provided on this website.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{ p: 4, flexDirection: "column", alignItems: "flex-start", gap: 3 }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              sx={{
                color: "var(--primary-color)",
                "&.Mui-checked": { color: "var(--primary-color)" },
              }}
            />
          }
          label={
            <Typography sx={{ fontSize: "0.9rem", color: "#666" }}>
              I have read and understood the above and I agree with the terms of
              usage of this website
            </Typography>
          }
        />
        <Button
          variant="contained"
          disabled={!isChecked}
          onClick={handleProceed}
          fullWidth
          sx={{
            bgcolor: "var(--primary-color)",
            py: 1.5,
            borderRadius: "50px",
            fontWeight: 800,
            fontSize: "1rem",
            textTransform: "none",
            boxShadow: "0 10px 20px rgba(26, 66, 161, 0.2)",
            "&:hover": {
              bgcolor: "#143380",
            },
            "&.Mui-disabled": {
              bgcolor: "rgba(0,0,0,0.12)",
              color: "rgba(0,0,0,0.26)",
            },
          }}
        >
          I Agree, Proceed to Website
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Disclaimer;
